import { httpPost } from "../http"

interface RequestTokenAuthorizedData {
  scopes: ["verified"]
}

interface RequestTokenAuthorizedResponse {
  request_code: string
}

export async function requestUpgradeAccessToken(
  data: RequestTokenAuthorizedData
): Promise<RequestTokenAuthorizedResponse> {
  const resp = await httpPost(
    `customer/v1/token/upgrade`,
    data,
    undefined,
    `api/v1/be-web-gateway/customer/v1/token/upgrade`
  )

  return resp?.data
}

interface UpgradeAccessTokenData {
  request_code: string
  otp_code: string
}
interface UpgradeAccessTokenResponse {
  access_token: string
  expires_in: number
  token_type: string
}

export async function upgradeAccessToken(
  data: UpgradeAccessTokenData
): Promise<UpgradeAccessTokenResponse> {
  const resp = await httpPost(
    `customer/v1/token/verify-upgrade`,
    data,
    undefined,
    `api/v1/be-web-gateway/customer/v1/token/verify-upgrade`
  )

  return resp?.data
}
